import { ChangeEvent, Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { MappedClientUserType } from '../../types';

interface IUsePageSearches {
  clientUsers: MappedClientUserType[];
  setFilteredClientUsers: Dispatch<SetStateAction<MappedClientUserType[]>>;
}

export default function usePageSearches({
  clientUsers,
  setFilteredClientUsers,
}: IUsePageSearches) {
  const [searchTerm, setSearchTerm] = useState('');

  const filterClientUsers = useCallback(() => {
    const filteredInternalUsers = clientUsers.filter((user) => {
      const searchTermFilters = user.name?.toLowerCase().includes(searchTerm.toLowerCase());

      return searchTermFilters;
    });

    setFilteredClientUsers(filteredInternalUsers);
  }, [clientUsers, searchTerm, setFilteredClientUsers]);

  useEffect(() => {
    filterClientUsers();
  }, [filterClientUsers]);

  const handleChangeSearchTerm = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  }, [setSearchTerm]);

  return {
    handleChangeSearchTerm,
    searchTerm,
  };
}
